import styled from "styled-components";

const Col = styled.div`
    @media (max-width: 575px) {
        
    }
`;
export default Col;
